import type { LucideIcon } from 'lucide-react';
import type { ReactNode } from 'react';

/**
 * Alerta informativa con icono al inicio y outline sutil — patrón medicus.com.ar
 * (ver image22 del QA del 16/05).
 *
 * Diferencia clave con los avisos previos: NO usa bg de color (azul/amarillo).
 * Solo outline `#000` 6% + icono celeste. Mantiene la jerarquía visual sin
 * "gritar".
 */
export function InfoAlert({
  icon: Icon,
  children,
  tone = 'neutral',
}: {
  icon: LucideIcon;
  children: ReactNode;
  /** 'neutral' (default) | 'warning' | 'error' */
  tone?: 'neutral' | 'warning' | 'error';
}) {
  const iconColor =
    tone === 'warning'
      ? 'var(--color-warning-dark)'
      : tone === 'error'
        ? 'var(--color-error-dark)'
        : 'var(--color-primary-lighter)';
  return (
    <aside
      style={{
        display: 'flex',
        alignItems: 'flex-start',
        gap: 12,
        padding: '12px 14px',
        borderRadius: 'var(--radius-md)',
        border: '1px solid var(--color-outline-sutil)',
        background: 'transparent',
        fontSize: 14,
        color: 'var(--color-element-mid)',
        lineHeight: 1.5,
      }}
    >
      <Icon size={20} strokeWidth={2} color={iconColor} style={{ flexShrink: 0, marginTop: 1 }} />
      <div style={{ flex: 1 }}>{children}</div>
    </aside>
  );
}
